import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppResource extends propertyTypes.Serializable {
    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }

}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("vacationListGridOptions", DataGridOptions)
        .addStateImplementation("ressurlaubGridOptions", DataGridOptions)
        .addStateImplementation("ressimpfGridOptions", DataGridOptions)
        .addStateImplementation("resspassGridOptions", DataGridOptions)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("translations", DataTranslations)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer);
    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", ResourceAppTranslations);
    public data: ResourceAppTranslations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class ResourceAppTranslations extends propertyTypes.Serializable {
    private Standard_Msg_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");
    private WebSMS_Vacation_UrlaubsdatenGespeichert = new propertyTypes.TranslatableTextProperty("WebSMS.Vacation.UrlaubsdatenGespeichert", "WebSMS.Vacation.UrlaubsdatenGespeichert");
    private Ressource_Einzelaufschlüsselung = new propertyTypes.TranslatableTextProperty("Ressource.Einzelaufschlüsselung", "Ressource.Einzelaufschlüsselung");
    private WebSMS_Vacation_GesamtübersichtDesJahres = new propertyTypes.TranslatableTextProperty("WebSMS.Vacation.GesamtübersichtDesJahres", "WebSMS.Vacation.GesamtübersichtDesJahres");
    private Field_Adresse_status = new propertyTypes.TranslatableTextProperty("Field.Adresse.status", "Field.Adresse.status");
    private Standard_Aktiviert = new propertyTypes.TranslatableTextProperty("Standard.Aktiviert", "Standard.Aktiviert");
    private Standard_AktivierungLaeuft = new propertyTypes.TranslatableTextProperty("Standard.AktivierungLaeuft", "Standard.AktivierungLaeuft");
    private Standard_Deaktiviert = new propertyTypes.TranslatableTextProperty("Standard.Deaktiviert", "Standard.Deaktiviert");
    private WebSMS_Resource_WindowsClientWirklichDeaktivieren = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.WindowsClientWirklichDeaktivieren", "WebSMS.Resource.WindowsClientWirklichDeaktivieren");
    private WebSMS_Resource_ActivationNotPossible = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.ActivationNotPossible", "WebSMS.Resource.ActivationNotPossible");
    private WebSMS_Resource_AppProfil = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.AppProfil", "WebSMS.Resource.AppProfil");

    private Server_Settings_ExportPath = new propertyTypes.TranslatableTextProperty("Server.Settings.ExportPath", "Server.Settings.ExportPath");
    private Server_SendData_NrRanges = new propertyTypes.TranslatableTextProperty("Server.SendData.NrRanges", "Server.SendData.NrRanges");
    private WebSMS_Resource_LetzerBelegEmpfangen = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.LetzerBelegEmpfangen", "WebSMS.Resource.LetzerBelegEmpfangen");
    private Standard_Aktivieren = new propertyTypes.TranslatableTextProperty("Standard.Aktivieren", "Standard.Aktivieren");
    private Standard_Deaktivieren = new propertyTypes.TranslatableTextProperty("Standard.Deaktivieren", "Standard.Deaktivieren");
    private Standard_Initialisieren = new propertyTypes.TranslatableTextProperty("Standard.Initialisieren", "Standard.Initialisieren");
    private WebSMS_Resource_Impfung = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.Impfung", "WebSMS.Resource.Impfung");
    private WebSMS_Resource_Schulung = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.Schulung", "WebSMS.Resource.Schulung");
    private WebSMS_Resource_Visum = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.Visum", "WebSMS.Resource.Visum");
    private WebSMS_Resource_Pass = new propertyTypes.TranslatableTextProperty("WebSMS.Resource.Pass", "WebSMS.Resource.Pass");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Standard_Msg_LoeschenMetadata, this.WebSMS_Vacation_UrlaubsdatenGespeichert, this.Ressource_Einzelaufschlüsselung,
        this.WebSMS_Vacation_GesamtübersichtDesJahres, this.Field_Adresse_status, this.Standard_Aktiviert,
        this.Standard_AktivierungLaeuft, this.Standard_Deaktiviert, this.WebSMS_Resource_WindowsClientWirklichDeaktivieren, this.WebSMS_Resource_ActivationNotPossible,
        this.WebSMS_Resource_AppProfil, this.Server_Settings_ExportPath, this.Server_SendData_NrRanges, this.WebSMS_Resource_LetzerBelegEmpfangen,
        this.Standard_Aktivieren, this.Standard_Deaktivieren, this.Standard_Initialisieren, this.WebSMS_Resource_Impfung, this.WebSMS_Resource_Schulung,
        this.WebSMS_Resource_Visum, this.WebSMS_Resource_Pass
        ];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}